module.exports = __webpack_public_path__ + "media/img/home/animate/screen2-32f74dffefaf9d84e845c1ae953e9b37.svg";